import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLazyload from 'vue-lazyload'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAnalytics from 'vue-analytics';

Vue.use(VueAxios, axios);

Vue.prototype.$eventBus = new Vue();

Vue.use(VueLazyload, {
  adapter: {

    observer: true,

    observerOptions: {
      rootMargin: '0px',
      threshold: 0.1
    }
  }
})


Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id: 'UA-131767181-1',
  router,
  debug: {
    enable: !isProd,
    sendHitTask: isProd
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
